// extracted by mini-css-extract-plugin
export default {"items":"variations-list_items__r9Y8s","item":"variations-list_item__Ks33C","button":"variations-list_button__GCaRg","handler":"variations-list_handler__hI8+w"};